"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputStyle = exports.AutoCompleteStyle = exports.DragNDropHandler = exports.ScrollableTableContainer = void 0;
const styles_1 = require("@mui/material/styles");
const TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
exports.ScrollableTableContainer = (0, styles_1.styled)(TableContainer_1.default)({
    maxHeight: "calc(100vh - 300px)",
    overflowY: "scroll",
});
exports.DragNDropHandler = (0, styles_1.styled)("td", {
    shouldForwardProp: (prop) => prop !== "isDragging",
})(({ theme, isDragging }) => ({
    color: isDragging
        ? theme.palette.institutional.braskemCyan
        : theme.palette.grayScale.gray4,
    padding: "0 12px",
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
}));
exports.AutoCompleteStyle = {
    backgroundColor: "#f7f7f7",
};
exports.InputStyle = {
    border: "none",
    outline: "none",
    backgroundColor: "transparent",
    "&:hover": {
        backgroundColor: "transparent",
    },
    "&::placeholder": {
        color: "#000",
    },
    fieldset: {
        backgroundColor: "transparent",
        borderColor: "transparent !important",
    },
    outlineColor: "transparent",
    borderColor: "transparent",
    "& .MuiOutlinedInput-root.Mui-error": {
        border: "1px solid #d32f2f",
    },
    "& .MuiFormHelperText-root.Mui-error": {
        fontWeight: "700",
    },
};
